export const EMOJI_MAP = {
  like: "👍",
  insightful: "💡",
  support: "🙌",
  celebrate: "👏",
  love: "❤️",
  funny: "😄",
  smile: "😄",
};

export const getEmoji = (type) => {
  if (!type) return "👍";
  const lower = type.toLowerCase();
  return EMOJI_MAP[lower] || type;
};
